import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import CardInteractive from '@/components/layout/CardInteractive.vue';
import NumberAnimation from '@/components/numberAnimation/NumberAnimation.vue';
import { redirectToIDP } from '@/utils/util';
var AuthItemPreview = /*#__PURE__*/function (_Vue) {
  function AuthItemPreview() {
    var _this;
    _classCallCheck(this, AuthItemPreview);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AuthItemPreview, [].concat(args));
    _defineProperty(_this, "authItem", void 0);
    _defineProperty(_this, "errorMsg", '');
    return _this;
  }
  _inherits(AuthItemPreview, _Vue);
  return _createClass(AuthItemPreview, [{
    key: "createAuthRequest",
    value: function createAuthRequest() {
      this.errorMsg = redirectToIDP(this.authItem);
    }
  }]);
}(Vue);
__decorate([Prop()], AuthItemPreview.prototype, "authItem", void 0);
AuthItemPreview = __decorate([Options({
  components: {
    NumberAnimation: NumberAnimation,
    CardInteractive: CardInteractive
  }
})], AuthItemPreview);
export default AuthItemPreview;